import { IEditableEntity } from '@zdrbm/zdr-native-tools';
import { useEventRefresher, useReadableEventRefresher } from '@zdrbm/zdr-react';
import { useEffect, useCallback } from 'react';
import { IPageLoaderManager } from '../../services/PageLoaderManager';

export function usePageLoaderManager<TItems extends IEditableEntity>(
    manager: IPageLoaderManager<TItems>,
) {
    useEventRefresher(manager.items.itemsAdded);
    useEventRefresher(manager.items.itemRemoved);

    const [[loadingState]] = useReadableEventRefresher(manager.loadingState);

    useEffect(() => {
        manager.loadMore();
    }, [manager]);

    const loadMore = useCallback(() => {
        manager.loadMore();
    }, [manager]);

    const removeItem = useCallback(
        (conversionId: string) => {
            manager.items.removeItem(conversionId);
        },
        [manager],
    );

    return {
        conversations: manager.items.getOrderedItems(),
        hasMore: manager.hasMore(),
        state: loadingState,
        loadMore,
        removeConversation: removeItem,
    };
}
